import {Injectable} from '@angular/core';
import {CartHeaderSection, JsonService, LineItemTexts, TransactionTypeAction, TypeValuePair} from '@dcp/configurator';
import {FormlyFieldConfig} from '@ngx-formly/core';
const CONFIGURATION: string = 'configuration';
const LINE_ITEM_TEXTS: string = 'lineItemTexts';
const ACTIONS: string = 'actions';
const CONFIGURATOR_FIELDS: string = 'configuratorFields';

@Injectable({
  providedIn: 'root',
})
export class TransactionTypeDataService {

  constructor(private jsonService: JsonService) {
  }

  public getBlocksConf(data: TypeValuePair[]): CartHeaderSection {
    return this.jsonService.parseSafely(this.jsonService.findDataSet(data, CONFIGURATION).value) as CartHeaderSection;
  }

  public getLineItemTexts(data: TypeValuePair[]): LineItemTexts {
    return this.jsonService.parseSafely(this.jsonService.findDataSet(data, LINE_ITEM_TEXTS).value) as LineItemTexts;
  }

  public getActions(data: TypeValuePair[]): TransactionTypeAction[] {
    return this.jsonService.parseSafely(this.jsonService.findDataSet(data, ACTIONS).value) as TransactionTypeAction[];
  }

  public getFormlyFieldConfig(data: TypeValuePair[]): FormlyFieldConfig[] {
    return this.jsonService.parseSafely(this.jsonService.findDataSet(data, CONFIGURATOR_FIELDS).value) as FormlyFieldConfig[];
  }
}
